/*
 * @Description: 图标加载
 * @Author: 琢磨先生
 * @Date: 2024-08-10 09:39:40
 * @LastEditors: 琢磨先生
 * @LastEditTime: 2024-08-12 08:28:36
 */
const load = require.context("./svg",false,/\.svg$/);
load.keys().map(load);
